import { Game } from "../game";

export class Camera {

    scale = 4;

    update(game: Game, dt: number) {}

    applyToContext(context: CanvasRenderingContext2D, scale: number=1) {}

}